import React, { useState, useEffect } from "react";

import { TextField, Button,
  Dialog, DialogActions, DialogContent,
  DialogTitle, Slide, IconButton,
} from "@mui/material";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

function DialogViewLicense({ open, setOpen, registro = null , setSnackbar }) {
  
  const handleDialogClose = () => {
    setOpen(false);
  };

  //si es un edit - llena los valores del registro
  //si es un nuevo registro - valores por default
  useEffect(() => {
    if(registro !== null && open)
    {
      
    }

  },[registro, open])

  
  return (
    <React.Fragment>
      <Dialog
        open={open}
        slots={{
          transition: Transition,
        }}
        keepMounted
        onClose={handleDialogClose}
        aria-describedby="alert-dialog-slide-description"
        PaperProps={{
          sx: {
            backgroundColor: "#555b5e",
            border: "1px solid",
            borderRadius: "10px",
            borderColor: "#555b5e",
            width: "300px"
          },
        }}
      >
        <DialogTitle>
          <p className="text-white font-bold"> Detalles de la Licencia </p>
        </DialogTitle>
        
        <DialogContent>
          <div className="  text-white text-[12px] ">

            <div className="grid grid-cols-2 gap-x-6 gap-y-3 mb-2">
              {/* Fila 1 */}
              <div>
                <span className="font-semibold">Nombre</span>
                <div>{registro?.name}</div>
              </div>
              <div>
                <span className="font-semibold">Permiso</span>
                <div>{registro?.entitlement}</div>
              </div>
              {/* Fila 2 */}
              <div>
                <span className="font-semibold">Estado</span>
                <div>{registro?.state === 1 ? "Valido" : registro?.state === 2 ? "Invalido" : "Expirado"}</div>
              </div>
              <div>
                <span className="font-semibold">Modelo</span>
                <div>{registro?.model === 1 ? "Floating" : "Fixes" }</div>
              </div>
              {/* Fila 3 */}
              <div>
                <span className="font-semibold">Tipo</span>
                <div>{registro?.type === 1 ? "Seat" : "Concurrent" }</div>
              </div>
              <div>
                <span className="font-semibold">Reservados</span>
                <div>{registro?.seats_reserved}</div>
              </div>
              {/* Fila 4 */}
              <div>
                <span className="font-semibold">Asientos en total</span>
                <div>{registro?.seats_total}</div>
              </div>
              <div>
                <span className="font-semibold"></span>
                <div></div>
              </div>
              {/* Fila 5 */}
              <div>
                <span className="font-semibold">Valido desde</span>
                <div>{registro?.valid_from}</div>
              </div>
              <div>
                <span className="font-semibold">Valido hasta</span>
                <div>{registro?.valid_until}</div>
              </div>
            </div>

          </div>

        </DialogContent>

        <DialogActions>
          <Button onClick={handleDialogClose}>
            <p className="text-rojo"> Cerrar </p>
          </Button>
        </DialogActions>
      
      </Dialog>
    </React.Fragment>
  );
}

export default DialogViewLicense;
